(function () {
  'use strict';

  function initCompleteSetInstance(completeSet) {
    if (!completeSet || completeSet.dataset.csInitialized === 'true') return;
    completeSet.dataset.csInitialized = 'true';

    const trayRadios = completeSet.querySelectorAll(
      'input[name="complete_set_tray"]',
    );
    const colourRadios = completeSet.querySelectorAll(
      'input[name="complete_set_colour"]',
    );
    const trayLabel = completeSet.querySelector('.tray-label');
    const colourLabel = completeSet.querySelector('.colour-label');
    const priceDisplay = completeSet.querySelector('#cs-total-price');
    const priceOriginal =
      priceDisplay === null || priceDisplay === void 0
        ? void 0
        : priceDisplay.querySelector('.complete-set-price-original');
    const priceDiscounted =
      priceDisplay === null || priceDisplay === void 0
        ? void 0
        : priceDisplay.querySelector('.complete-set-price-discounted');
    const discountPercent = parseFloat(
      (priceDisplay === null || priceDisplay === void 0
        ? void 0
        : priceDisplay.dataset.discountPercent) || '0',
    );
    const productImage = completeSet.querySelector('#cs-product-image');
    const form = completeSet.querySelector('#complete-set-form');
    const mainVariantInput = form.querySelector('.cs-main-variant');
    if (!form || !mainVariantInput) return;

    function ensureDefaultSelections() {
      if (
        !completeSet.querySelector('input[name="complete_set_tray"]:checked') &&
        trayRadios.length
      ) {
        trayRadios[0].checked = true;
      }
      if (
        !completeSet.querySelector(
          'input[name="complete_set_colour"]:checked',
        ) &&
        colourRadios.length
      ) {
        colourRadios[0].checked = true;
      }
    }

    function updateSelectionUI() {
      trayRadios.forEach((radio) => {
        const label = radio.closest('.complete-set-pill');
        if (!label) return;
        label.classList.toggle('is-selected', radio.checked);
        label.setAttribute('aria-checked', radio.checked ? 'true' : 'false');
      });

      colourRadios.forEach((radio) => {
        const label = radio.closest('.complete-set-pill');
        if (!label) return;
        label.classList.toggle('is-selected', radio.checked);
        label.setAttribute('aria-checked', radio.checked ? 'true' : 'false');
      });

      const selectedTray = completeSet.querySelector(
        'input[name="complete_set_tray"]:checked',
      );
      const selectedColour = completeSet.querySelector(
        'input[name="complete_set_colour"]:checked',
      );

      if (trayLabel) {
        trayLabel.textContent =
          !selectedTray || selectedTray.value === 'none' ? 'None' : 'Timber';
      }
      if (selectedColour && colourLabel) {
        colourLabel.textContent = selectedColour.dataset.variantTitle;
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }

    function updateImage() {
      const selectedTray = completeSet.querySelector(
        'input[name="complete_set_tray"]:checked',
      );
      const selectedColour = completeSet.querySelector(
        'input[name="complete_set_colour"]:checked',
      );

      if (selectedTray && selectedTray.value !== 'none') {
        // Show tray image if tray is selected
        const trayImage = selectedTray.dataset.trayImage;
        if (trayImage && trayImage !== 'null' && trayImage !== '') {
          productImage.src = trayImage;
          return;
        }
      }

      // Otherwise show main variant image
      if (selectedColour && selectedColour.dataset.variantImage) {
        const imageUrl = selectedColour.dataset.variantImage;
        if (imageUrl && imageUrl !== 'null' && imageUrl !== '') {
          productImage.src = imageUrl;
        }
      }
    }

    // Update price
    function updatePrice() {
      const selectedColour = completeSet.querySelector(
        'input[name="complete_set_colour"]:checked',
      );
      const selectedTray = completeSet.querySelector(
        'input[name="complete_set_tray"]:checked',
      );

      let total = 0;
      let compareTotal = 0;
      if (selectedColour) {
        const p = parseFloat(selectedColour.dataset.variantPrice || 0) || 0;
        const c = parseFloat(selectedColour.dataset.variantCompare || 0) || 0;
        total += p;
        compareTotal += c > p ? c : p;
      }
      if (selectedTray && selectedTray.value !== 'none') {
        const p = parseFloat(selectedTray.dataset.trayPrice || 0) || 0;
        const c = parseFloat(selectedTray.dataset.trayCompare || 0) || 0;
        total += p;
        compareTotal += c > p ? c : p;
      }

      let discountedTotal = total;
      if (discountPercent > 0) {
        const discountAmount = (total * discountPercent) / 100;
        discountedTotal = total - discountAmount;
      }

      if (discountPercent > 0 && priceOriginal && priceDiscounted) {
        priceOriginal.textContent = formatMoney(total);
        priceDiscounted.textContent = formatMoney(discountedTotal);
      } else if (discountPercent > 0) {
        priceDisplay.textContent = formatMoney(discountedTotal);
      } else if (compareTotal > total) {
        // No manual discount, but the selected configuration is on sale:
        // show the combined compare-at price struck through.
        priceDisplay.innerHTML =
          '<div class="complete-set-price-container">' +
          '<span class="complete-set-price-original">' +
          formatMoney(compareTotal) +
          '</span>' +
          '<span class="complete-set-price-discounted">' +
          formatMoney(total) +
          '</span>' +
          '</div>';
      } else {
        priceDisplay.innerHTML =
          '<span class="complete-set-price-regular">' +
          formatMoney(total) +
          '</span>';
      }
    }

    // Update hidden form inputs (like your PDP addon does)
    function updateFormInputs() {
      const selectedColour = completeSet.querySelector(
        'input[name="complete_set_colour"]:checked',
      );
      const selectedTray = completeSet.querySelector(
        'input[name="complete_set_tray"]:checked',
      );

      // Remove old tray inputs
      form.querySelectorAll('.cs-tray-input').forEach((el) => el.remove());

      // Update main variant
      if (selectedColour) {
        mainVariantInput.value = selectedColour.value;
      }

      // Add tray as second item if selected
      if (selectedTray && selectedTray.value !== 'none') {
        const trayIdInput = document.createElement('input');
        trayIdInput.type = 'hidden';
        trayIdInput.name = 'items[1][id]';
        trayIdInput.value = selectedTray.value;
        trayIdInput.classList.add('cs-tray-input');
        form.appendChild(trayIdInput);

        const trayQtyInput = document.createElement('input');
        trayQtyInput.type = 'hidden';
        trayQtyInput.name = 'items[1][quantity]';
        trayQtyInput.value = '1';
        trayQtyInput.classList.add('cs-tray-input');
        form.appendChild(trayQtyInput);
      }
    }

    // Handle tray change
    trayRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        updateSelectionUI();
        updatePrice();
        updateFormInputs();
        updateImage();
      });
    });

    // Handle colour change
    colourRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        updateSelectionUI();
        updateImage();
        updatePrice();
        updateFormInputs();
      });
    });

    // Initialize
    ensureDefaultSelections();
    updateSelectionUI();
    updatePrice();
    updateFormInputs();
    updateImage();
  }

  function initCompleteSets(root = document) {
    const containers = root.querySelectorAll('[data-complete-set]');
    containers.forEach(initCompleteSetInstance);
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCompleteSets());
  } else {
    initCompleteSets();
  }

  // Re-initialize on section load
  document.addEventListener('shopify:section:load', (event) =>
    initCompleteSets(event.target || document),
  );
  document.addEventListener('shopify:section:reopen', (event) =>
    initCompleteSets(event.target || document),
  );
})();
